module.exports = __webpack_public_path__ + "img/telegram.79339c88.svg";